import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axios from '../../../utils/axios';
import { FetchArrangeManualGroupDetail } from './fetch-arrange-manual';

export namespace CreateArrangeManual {
  export type RequestType = {
    title: string;
    movieId: string;
    isImportant: boolean;
    arrangeManualGroupId: number;
    thumbnailImageAttachmentId: number | null;
    code: string;
  };

  export const useMutate = ({
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, RequestType> = {}) => {
    const { refetch } = FetchArrangeManualGroupDetail.useRefetchData();

    const mutation = useMutation(
      ({
        isImportant,
        movieId,
        title,
        arrangeManualGroupId,
        thumbnailImageAttachmentId,
        code
      }) => {
        return axios.post(`/arrange-manual/group/${arrangeManualGroupId}`, {
          isImportant,
          movieId,
          title,
          thumbnailImageAttachmentId,
          code
        });
      },
      {
        onSuccess: (...rest) => {
          refetch({ arrangeManualGroupId: rest[1].arrangeManualGroupId });
          onSuccess?.(...rest);
        },
        ...options
      }
    );

    return mutation;
  };
}
